import * as React from 'react';
import styled from 'styled-components';

const SIZE = 56;

const Img = styled.img`
  min-height: ${SIZE}px;
  min-width: ${SIZE}px;
  max-height: ${SIZE}px;
  max-width: ${SIZE}px;
  cursor: ${(p) => (p.$pointer || p.onClick ? 'pointer' : 'default')};
`;

const LoveColor56 = (props) => (
  <Img src="/static/img/svg/giftcard-love-56.svg" alt="" {...props} />
);

export default LoveColor56;
